import { chunk } from "lodash/fp";

import Typography from "@mui/material/Typography";

import { AUTH_PROVIDER_BUTTON_STYLE_OVERRIDES } from "@app/analytics/auth/components/styles";
import ProviderButton from "@app/analytics/components/ProviderButton";
import { SIGNUP_SSO_PROVIDERS } from "@app/common/constants/providers";
import type { SSOProviderId } from "@app/common/types/providerTypes";
import Config from "@app/config";

import { Column, Row } from "@rui/Stack";
import { Img } from "@rui/styles";

const PROVIDER_CHUNKS = chunk(2, SIGNUP_SSO_PROVIDERS);

const SignupProviders = ({
  onClickProvider,
}: {
  onClickProvider: (providerId: SSOProviderId) => void;
}) => {
  return (
    <Column spacing={2}>
      <Row variant="center">
        <Typography variant="bodySecondaryMed" color="shades.neutral.400">
          Sign up with:
        </Typography>
      </Row>
      {PROVIDER_CHUNKS.map((providers, i) => (
        <Row
          key={i}
          spacing={2}
          variant="center"
          flexWrap={Config.flags.googleReview ? "wrap" : "nowrap"}
        >
          {providers.map((provider) => (
            <ProviderButton
              key={provider.id}
              icon={
                <Img
                  src={provider.icon}
                  alt={`Sign up with ${provider.displayName}`}
                />
              }
              providerId={provider.id}
              onClick={() => onClickProvider(provider.id)}
              sx={AUTH_PROVIDER_BUTTON_STYLE_OVERRIDES}
              type="submit"
              // prevent internal loading state
              loading={false}
            >
              {Config.flags.googleReview && "Sign up with "}
              {provider.displayName}
            </ProviderButton>
          ))}
        </Row>
      ))}
    </Column>
  );
};

export default SignupProviders;
